import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const fetchError = type => errorHandlerFactory(`An error occured when fetching ${type} Mappings.`);
const createMappingError = mapping => errorHandlerFactory(`An error occured when creating a new ${mapping} Mappings.`);
const deleteRowError = mapping => errorHandlerFactory(`An error occured when creating deleting a row in ${mapping} mappings`);
const editRowError = mapping => errorHandlerFactory(`An error occured when creating editing a row in ${mapping} mappings`);
const fetchOptionsError = option => errorHandlerFactory(`An error occured when creating fetching ${option} options`);

export const commodityMapping = () => axios.get('/mapping/commodity')
    .then(r => r.data).catch(fetchError('Commodity'));

export const isdaCurveMapping = () => axios.get('/mapping/isdacurve')
    .then(r => r.data).catch(fetchError('Isda Curve'));

export const iceIsinMapping = () => axios.get('/mapping/icebucket')
    .then(r => r.data).catch(fetchError('ISIN'));

export const equitySedol = () => axios.get('/mapping/EquitySedolIsin')
    .then(r => r.data).catch(fetchError('Equity Sedol'));

export const standardProductMapping = () => axios.get('/Mapping/StandardProductClass')
    .then(r => r.data).catch(fetchError('Standard Product'));

export const currencyMapping = () => axios.get('Mapping/CurrencyMapping')
    .then(r => r.data).catch(fetchError('Currency Mapping'));

export const createIsdaSubCurveMapping = params => axios.post('/mapping/AddCurveMapping', params)
    .then(r => r.data).catch(createMappingError('ISDA Sub Curve'));

export const createCommodityMapping = params => axios.post('/mapping/AddCommodity', params)
    .then(r => r.data).catch(createMappingError('Commodity'));

export const createEquityMapping = params => axios.post('/mapping/AddEquityNonIsin', params)
    .then(r => r.data).catch(createMappingError('Equity'));

export const createCurrencyMapping = params => axios.post('/mapping/AddCurrencyMapping', params)
    .then(r => r.data).catch(createMappingError('Currency Mapping'));

export const deleteRowIsdaSubCurve = id => axios.post('/mapping/DeleteCurveMapping', null, { params: { id } })
    .then(r => r.data).catch(deleteRowError('ISDA'));

export const deleteRowCommodity = id => axios.post('/mapping/DeleteCommodity', null, { params: { id } })
    .then(r => r.data).catch(deleteRowError('Commodity'));

export const deleteRowEquity = id => axios.post('/mapping/DeleteEquityNonIsin', null, { params: { id } })
    .then(r => r.data).catch(deleteRowError('Equity'));

export const deleteCurrencyRow = id => axios.post('/mapping/DeleteCurrencyMapping', null, { params: { id } })
    .then(r => r.data).catch(deleteRowError('Currency Mapping'));

export const editRowIsdaSubCurve = params => axios.post('/mapping/EditCurveMapping', params)
    .then(r => r.data).catch(editRowError('ISDA'));

export const editRowCommodity = params => axios.post('/mapping/EditCommodity', params)
    .then(r => r.data).catch(editRowError('Commodity'));

export const editRowEquity = params => axios.post('/mapping/EditEquityNonIsin', params)
    .then(r => r.data).catch(editRowError('Equity'));

export const editCurrencyMappingRow = params => axios.post('/mapping/EditCurrencyMapping', params)
    .then(r => r.data).catch(editRowError('Currency Mapping'));

export const editStandardProductClass = params => axios.post('/mapping/EditStandardProductClass', params)
    .then(r => r.data).catch(editRowError('Standard Product Class'));

export const fetchCommodityMappingOptions = () => axios.get('/Mapping/IsdaCommodities')
    .then(r => r.data).catch(fetchOptionsError('Isda Commodity'));

export const fetchIsdaMappingOptions = () => axios.get('/Mapping/IsdaCurveMappings')
    .then(r => r.data).catch(fetchOptionsError('Isda Curve'));

export const fetchCurrencyMappingOptions = () => axios.get('/Mapping/OffshoreCurrencyList')
    .then(r => r.data).catch(fetchOptionsError('Currency Mapping'));
